module.exports = __webpack_public_path__ + "static/media/Afiliate_LOGO_1_wht_1x.269a1cbf.png";